<template>
  <div style="padding-top: 10rem" class="px-5">
    <div v-if="locale == 'pt'" class="row">
      <h2>
        Parabéns por dar um passo importante em direção ao sorriso dos sonhos!
      </h2>
      <div class="col-md-3"></div>
      <div class="col-md-6">
        <p class="px-5 pt-5">
          É com imensa alegria que recebemos o seu contato.
        </p>
        <p>
          Saiba que estamos ansiosos para fazer parte dessa jornada incrível
          junto com você.
        </p>
        <p>
          Aqui na Sorrifácil, acreditamos que cada sorriso é único e especial, e
          estamos comprometidos em transformar o seu em uma verdadeira
          obra-prima!
        </p>
        <p>Nossa equipe vai entrar em contato o mais breve possível.</p>
        <p>
          Logo, você receberá uma resposta completa, esclarecendo todas as suas
          dúvidas e fornecendo todas as informações necessárias para que
          possamos começar esse processo emocionante.
        </p>
      </div>
      <div class="col-md-3"></div>
    </div>

    <div v-if="locale == 'es'" class="row">
      <h2>
        ¡Felicidades por dar un paso importante hacia la sonrisa de tus sueños!
      </h2>
      <div class="col-md-3"></div>
      <div class="col-md-6">
        <p class="px-5 pt-5">Es con gran alegría que recibimos su contacto.</p>
        <p>
          Tenga en cuenta que esperamos ser parte de este increíble viaje.
          contigo.
        </p>
        <p>
          En Sorrifácil creemos que cada sonrisa es única y especial, y estamos
          comprometidos a transformar el tuyo en un verdadero ¡obra maestra!
        </p>
        <p>Nuestro equipo se pondrá en contacto contigo lo antes posible.</p>
        <p>
          En breve, recibirá una respuesta completa, aclarando todas sus
          preguntas y proporcionando toda la información necesaria para que
          podemos comenzar este emocionante proceso.
        </p>
      </div>
      <div class="col-md-3"></div>
    </div>

    <div class="my-5">
      <NuxtLink
        class="botao botao-laranja"
        :to="localePath('tratamentos', locale)"
      >
        {{ $t("Conheça nossos tratamentos") }}
      </NuxtLink>
    </div>
  </div>

  <site-noticias />
</template>

<script setup>
const { t, locale } = useI18n();
const localePath = useLocalePath();

useSeoMeta({
  title: t("Obrigado por entrar em contato com a ") + t("sorrifacil"),
  ogTitle: t("Obrigado por entrar em contato com a ") + t("sorrifacil"),
  description: t("Obrigado por entrar em contato com a ") + t("sorrifacil"),
  ogDescription: t("Obrigado por entrar em contato com a ") + t("sorrifacil"),
});
</script>

<script>
export default {
  name: "AgradecimentoPagina",
};
defineI18nRoute({
  paths: {
    pt: "/agradecimento",
    es: "/gracias",
  },
});
</script>
